import type { OrganizationModel } from "@package/ui-gql/index-data-access";
import { createContext, useContext } from "react";

export type OrganizationContextState = {
  loading: "idle" | "pending" | "succeeded" | "failed";
  organizations: OrganizationModel[];
  selectedOrganization?: OrganizationModel;
  setSelectedOrganization: (
    organization:
      | OrganizationModel
      | ((prev?: OrganizationModel) => OrganizationModel),
  ) => void;
};

export const defaultOrganizationState: OrganizationContextState = {
  loading: "idle",
  organizations: [],
  setSelectedOrganization: () => undefined,
};

export const OrganizationStateContext = createContext<OrganizationContextState>(
  defaultOrganizationState,
);
export const useOrganizationState = () => useContext(OrganizationStateContext);
